<template>
    <div class="enterprisewebsite" v-title data-title="报告详情" data="newsdetail">
        <leftnav class="fl"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader ></govheader>
            <div class="index_left_centerpage flexcss">

                <div class="leftconbox">                                                           
                </div>
            </div>

        </div>

        <!-- <footerbar v-if="userdata.userType>1"></footerbar> -->
    </div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
    name: 'newsdetail',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            userdata: {},
            id:{},
        }
    },
    components: {
        freeUserTips
    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");
            // 禁用选择
            document.onselectstart = new Function("event.returnValue=false");
        });
        this.userdata = this.getuseriformation();
        this.id = this.$route.query.id * 1;
    },
    mounted() {
    },
    methods: {

    }
}



</script>

<style scoped="scoped">
.leftconbox {
    min-height: 840px;
}
</style>
